import React, {useCallback, useEffect, useState} from "react";
import {withRouter} from "react-router";
import {Col, Layout, Menu, Row, Typography} from "antd";
import cubejs from "@cubejs-client/core";
import {CubeProvider} from "@cubejs-client/react";
import {Provider} from 'mobx-react';
import rootStore from "./stores/rootstore";

import Header from './components/Menus/Header';
import AppBreadcrumbs from "./components/Common/AppBreadcrumbs";
import {Spinner} from "./components/Spinner";
import './css/human-body.css'
import './App.css'
import {RouteConfig, useRoutes} from "./router";
import LoginPage from "./pages/LoginPage";
import {AuthContext} from "./context/AuthContext";
import {useAuth} from "./hooks/auth.hook";
import {NO_BACKEND} from "./config/runtime";
import useReactRouterBreadcrumbs from "use-react-router-breadcrumbs";

const {Content, Footer} = {...Layout}

// Режим работы без бэкенда: пропускаем проверку сервера и авторизацию.
// username должен начинаться с 'admin_' — по этому префиксу MainPageCard
// решает, показывать ли карточки моделей (см. components/MainPageCard.js).
const DEV_USER = {username: 'admin_dev', name: 'Разработчик', roles: ['admin']}

const cubejsApi = (token) => cubejs(token, {
  apiUrl: '/cubejs-api/v1'
});

const AppLayout = ({ location, children, match }) =>
{
    return(
    <Layout className="layout"  style={{ height: "100%" , "backgroundColor": "transparent"}}>

            <Header location={location}/>

    <Content className={"app-content"}>
        {// <AppBreadcrumbs location={location} match={match}></AppBreadcrumbs>
             }
        <div className="site-layout-content">{children}</div>
    </Content>
    <Footer style={{textAlign: 'center', fontSize: 12}}>© 2019–2026 Digital Twin</Footer>
</Layout>
    )
}


function WarningServeOffline() {
    return <Row><Col span={4} offset={10}><Spinner>Сервер не доступен, ожидаем запуска сервера</Spinner>
        <Typography.Title level={4}>Сервер не доступен, ожидаем запуска сервера или подключения к
            серверу</Typography.Title>
        <Typography.Text type={"secondary"}>Если Вы видите это сообщение, значит на сервере идут технические работы,
            либо у Вас нестабильное подключение к сети</Typography.Text>
    </Col>
    </Row>;
}

const App = withRouter(({ location, children, match }) => {
    const [serverIsOnline, setServerIsOnline] = useState(NO_BACKEND);
    const [tryCount, setTryCount] = useState(0)
    const {token, login, logout, userId, user, userType, nsi, ready, cubeToken} = useAuth()

    const isAuthenticated = NO_BACKEND || (!!token && !!user)
    // logout() (например, по 401 от чужого сервера) ставит user = {} —
    // пустой объект «правдив», поэтому проверяем именно username.
    const effectiveUser = NO_BACKEND ? (user && user.username ? user : DEV_USER) : user
    const effectiveToken = token || (NO_BACKEND ? process.env.REACT_APP_CUBEJS_TOKEN : token)
    const routes = useRoutes(isAuthenticated)

    useEffect(() => {
        document.title = `Digital Twin`}, []);


    const checkServer = useCallback(async () => {
        if (NO_BACKEND) return true
        console.log('test server connection...', tryCount)
        try {
            const init = {method:  'GET'}
            const resp = await fetch(`/api/basic/online`, init)
            const online = (await resp.json()).status

            if (!serverIsOnline)
            {
                console.log('test server connection...', online)
                setTimeout(
                    () => setTryCount(tryCount => tryCount + 1)
                    , 1000)



                setServerIsOnline(serverIsOnline => serverIsOnline || online)
            }
        } catch (e) {
            console.log('fail...', tryCount)
            setTimeout( () => setTryCount(tryCount   => tryCount + 1, 1000), 1000)
            return false;
        }
    })

    useEffect(() => {if (!NO_BACKEND) checkServer()}, [tryCount])


    if (!serverIsOnline)
        return <WarningServeOffline/>
    else
            return (
                <Provider {...rootStore}>
                    <AuthContext.Provider
                        value={{token: effectiveToken, login, logout, userId, nsi, userType, user: effectiveUser, isAuthenticated}}>
                        {!isAuthenticated ? <LoginPage/> :
                                <CubeProvider cubejsApi={cubejsApi(effectiveToken)}>
                                    <AppLayout location={location} match={match} theme={"light"}>{routes}</AppLayout>
                                </CubeProvider>
                        }
                    </AuthContext.Provider>
                </Provider>)
});

export default App;
